var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCircleChecked30Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.480469,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#0033AD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9805 8C11.8384 8 8.48047 11.3579 8.48047 15.5C8.48047 19.6423 11.8384 23 15.9805 23C20.1228 23 23.4805 19.6423 23.4805 15.5C23.4805 11.3579 20.1228 8 15.9805 8ZM15.9805 22.0773C12.362 22.0773 9.41797 19.1185 9.41797 15.5C9.41797 11.8815 12.362 8.93747 15.9805 8.93747C19.599 8.93747 22.543 11.8815 22.543 15.5C22.543 19.1185 19.599 22.0773 15.9805 22.0773ZM18.9737 12.7557L14.5733 17.1837L12.5916 15.2021C12.4086 15.0191 12.1119 15.0191 11.9286 15.2021C11.7455 15.3852 11.7455 15.6819 11.9286 15.8649L14.2487 18.1852C14.4317 18.368 14.7284 18.368 14.9117 18.1852C14.9328 18.1641 14.9509 18.1412 14.9673 18.1173L19.637 13.4187C19.8198 13.2357 19.8198 12.939 19.637 12.7557C19.4537 12.5727 19.157 12.5727 18.9737 12.7557Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCircleChecked30Px);
export default __webpack_public_path__ + "static/media/ic_circle_checked_30px.2c791250e1acafb121fa5fc1ba6dbe0c.svg";
export { ForwardRef as ReactComponent };